import { Add } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import AuthorizationGate from 'components/authorization-gate/authorization-gate.component';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import SearchProvider from 'components/search/search.context';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import GroupsDataGrid from '../groups-data-grid/groups-data-grid.component';
import { useGroupsFilters } from '../groups-landing.hooks';
import BulkEditDataGridProvider from 'components/inc-data-grid/bulk-edit-data-grid/bulk-edit-data-grid.context';

const GroupsNative = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const search = useGroupsFilters(false);

  return (
    <Box mt={2}>
      <SearchProvider value={search}>
        <SearchToolbar
          buttons={
            <AuthorizationGate permission="CREATE_GROUP">
              <Button
                onClick={() => navigate('../create')}
                startIcon={<Add />}
                data-testid="Groups.Button.CreateGroup"
                sx={{ whiteSpace: 'nowrap' }}
                variant="text"
              >
                {t('GroupsDataGrid.buttons.create')}
              </Button>
            </AuthorizationGate>
          }
        />
        <BulkEditDataGridProvider>
          <GroupsDataGrid />
        </BulkEditDataGridProvider>
      </SearchProvider>
    </Box>
  );
};

export default GroupsNative;
